<template>
  <span class="tooltip"
    ><i class="material-icons" style="margin-right: 3px;">error_outline</i>
    Subtotal:
    <div class="tooltip_popup">
      <section class="tooltip_details">
        <table class="tooltip_table">
          <tr>
            <th class="-text-blue">
              <h3 class="mt-0 mb-0">{{ time.DisplayName }}</h3>
            </th>
            <td></td>
          </tr>
          <tr
            v-for="(r, i) in time.Rates"
            :key="i + '-sub-total-tool-tip-rates-' + time.Value"
            v-show="r.Participants > 0"
          >
            <td>
              <!--              <pre>r.Participants: {{ r.Participants }}</pre>-->
              <!--              <pre>r.IsPrivateTourRate: {{ r.IsPrivateTourRate }}</pre>-->
              <!--              <pre>hasPrivateTourRate: {{ hasPrivateTourRate }}</pre>-->

              {{ r.Name }}
              <span class="text-pencil-light">
                &nbsp;
                <currency
                  v-if="
                    (hasPrivateTourRate && r.IsPrivateTourRate) ||
                      !hasPrivateTourRate
                  "
                  :fixed="true"
                  :value="r.Price"
                />
                x {{ r.Participants }}</span
              >
            </td>
            <td align="right">
              <currency
                v-if="
                  (hasPrivateTourRate && r.IsPrivateTourRate) ||
                    !hasPrivateTourRate
                "
                :fixed="true"
                :value="r.Price * r.Participants"
              />
              <currency v-else :fixed="true" :value="0" />
            </td>
          </tr>
          <tr
            v-for="(a, i) in time.AddOns"
            :key="i + '-sub-total-tool-tip-addons-' + time.Value"
            v-show="a.Quantity"
          >
            <td>
              {{ a.AddOnName }}

              <span class="text-pencil-light" v-if="!a.IsBoolean">
                &nbsp;
                <currency
                  :fixed="true"
                  :value="
                    a.PublishedPrice - (a.AddOnDiscount ? a.AddOnDiscount : 0)
                  "
                />&nbsp;x&nbsp;{{ a.Quantity }}</span
              >
              <!--                          <pre>{{ a }}</pre>-->
            </td>
            <td align="right">
              <currency
                :fixed="true"
                :value="
                  (a.PublishedPrice - (a.AddOnDiscount ? a.AddOnDiscount : 0)) *
                    a.Quantity
                "
              />
            </td>
          </tr>
        </table>
      </section>
    </div>
  </span>
</template>

<script>
export default {
  name: "SubTotalToolTip",
  props: ["time"],
  computed: {
    hasPrivateTourRate() {
      return !!this.time.Rates.find(rate => {
        return rate.Participants > 0 && rate.IsPrivateTourRate;
      });
    }
  }
};
</script>

<style scoped></style>
